export const ADD_NEW_HIGHLIGHT = `mutation ($name: String!, $icon: String!) {
    add_new_highlight(name: $name, icon: $icon){
      message
    }
  }
`;

export const ACTIVATE_HIGHLIGHT = `mutation ($id : String!) {
    activate_highlight(_id: $id){
      message
    }
  }
`;

export const LIST_ALL_HIGHLIGHTS = `query ($pageSize: Int, $pageNumber: Int) {
    list_all_highlights(page_size: $pageSize, page_number: $pageNumber){
      message
      data {
        _id
        name
        icon
        is_active
      }
      hasMore
    }
  }
`;

export const ADD_NEW_BOOKING = `mutation ($users: [String]!, $prizes: [String], $ads: [String]) {
  host_a_game(users: $users, prizes: $prizes, ads: $ads){
    message
  }
}
`;

export const LIST_ALL_BOOKINGS = `query{
  list_all_games{
    message
    data {
      _id
      status
    }
  }
}
`;

export const ADD_NEW_USER = `mutation ($email: String!) {
  create_user(email: $email){
    message
  }
}
`;

export const UserInput = `
  input UserInput {
    email: String!
    name: String!
    groupName: String!
  }
`;

export const ADD_NEW_USER_BULK = `
  mutation ($users: [create_bulk_user_users]!, $sendEmail: Boolean!) {
    create_bulk_user(users: $users, sendEmail: $sendEmail) {
      message
    }
  }
`;


export const LIST_ALL_USERS = `query{
  list_all_users{
    message
    data {
      _id
      email
      username
    }
  }
}
`;

export const JOIN_GROUP = `mutation AddUserToGroup($group_id: String!) {
  add_user_to_group(args: { group_id: $group_id }) {
    success
    message
  }
}
`;

export const LIST_USER_DETAILS = `query{
  list_user_details{
    message
    data {
      _id
      email
      username
    }
  }
}
`;

export const LIST_PUBLIC_GROUPS = `query {
  list_public_groups {
    message
    data {
      _id
      name
      start_time
      status
      users
      organizer_id {
        _id
        username
      }
    }
  }
}`;

export const LIST_ALL_USER_GAMES = `
  query list_all_user_games($userId: String!) {
    list_all_user_games(userId: $userId) {
      message
      data {
        _id
        organizer_name
        users
        status
        createdAt
        updatedAt
      }
    }
  }
`;

export const ADD_NEW_FACILITY = `mutation ($name: String!, $icon: String!) {
    add_new_facility(name: $name, icon: $icon){
      message
    }
  }
`;

export const LIST_ALL_FACILITIES = `query ($pageSize: Int, $pageNumber: Int) {
    list_all_facilities(page_size: $pageSize, page_number: $pageNumber){
      message
      data {
        _id
        name
        icon
        is_active
      }
      hasMore
    }
  }
`;

export const CREATE_GROUP = `
  mutation CreateGroup($args: create_group_args!) {
    create_group(args: $args) {
      message
    }
  }
`;

export const UPDATE_GROUP = `
  mutation EditGroup($args: edit_group_args!) {
    edit_group(args: $args) {
      message
    }
  }
`;

export const LIST_ALL_GROUPS = `
  query {
    list_all_groups{
      message
      data {
        _id
        name
        status
        organizer_id
        users {
          _id
          username
          email
        }
        start_time
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_CURRENT_CARD_DATA = `query ($username: String!, $game_id: String!) {
  list_user_cards(username: $username, game_id: $game_id){
    message
    data {
      _id
      card
      user_id {
        _id
        username
      }
      organizer_id {
        _id
        username
      }
      game_id {
        _id
        status
      }
    }
    newcall
  }
}`;

export const CREATE_ADVERTISEMENT = `
  mutation ($args: create_advertisement_args!) {
    create_advertisement(args: $args) {
      success
      message
    }
  }
`;

export const LIST_ALL_ADS = `
  query {
    list_all_ads {
      success
      message
      advertisements {
        id         
        name
        media_type
        media_url
        org_id
        createdAt
        updatedAt
      }
    }
  }
`;





